<div class="page legacy-page overlayed" id="account-page">
    <div class="action-bar dark-bg">
        <div class="title no-margin">
            Tu cuenta
        </div>
        <div class="actions-set">
            <a class="action-btn done SaveBtn" href="#"></a>
            |
            <a class="action-btn sos" href="#">SOS</a>
        </div>
    </div>
    <div class="page-overlay"></div>
	<div class="content with-sidebar">
		<div class="sidebar"></div>
		<div class="container legacy-container">
			<div class="section" id="cuenta">
                    <form class="legacy-form">
    		            <a class="action-btn CancelBtn" icon="cancel" href="#home"></a>
                        <h2 class="StringCtrl required" property="name">
							<input size="30" name="name" placeholder="Nombre"/>
                            <p class="hint">Ingrese el nombre de su empresa aquí. Este campo es necesario.</p>
						</h2>
                        <br/>
                        <ul>
							<li class="SelectCtrl" property="status">
								<label>Estado</label>
								<select>
									<option value="A">Activa</option>
									<option value="S">Suspendida</option>
								</select>
                                <p class="hint">Si suspende el servicio mantendremos los datos de su cuenta por
                                treinta dias, y luego borraremos sus datos. Usted puede reactivar el uso de su cuenta en cualquier momento
                                durante dicho período.</p>
							</li>
							<li class="StringCtrl" property="field">
								<label>Rubro </label>
                                <input size="30" placeholder="Rubro"/>
                                <p class="hint">Actividad en la que se desenvuelve. Es solo informativo y para
                                mejorar la calidad de nuestros servicios. Ej: "Ind. Quimica/Aerosoles".</p>
							</li>
							<li class="SelectCtrl required" property="country">
								<label>País <b>*</b></label>
								<select name="country">
									<option value="AR">Argentina</option>
                                    <option value="UY">Uruguay</option>
                                    <option value="CL">Chile</option>
								</select>
							</li>
                            <li class="StringCtrl" property="www">
                                <label>Sitio web</label>
                                <input name="website" class="big" size="30" placeholder="Sitio web"/>
                                <p class="hint">Si su empresa tiene un sitio web, puede ingresar su
                                    dirección aquí. Ejemplo: "treme.com.ar" o "www.analyte.com".</p>
                            </li>
                            <li class="TextCtrl" property="address_info">
                                <label>Dirección</label>
                                <textarea name="address" rows="1" placeholder="Dirección de la empresa."></textarea>
                                <p class="hint">Es el lugar donde enviaremos la factura.</p>
                            </li>
                            <li class="TextCtrl" property="logo">
                                <label>El logo</label>
                                <p class="image-container">
                                    <img src="../img/extras/frame.png"/>
                                    <input type="file" id="account-logo-upload-btn" no-style="display:none;"/>
                                </p>
                                <textarea name="logo" class="hidden"></textarea>
                                <p class="hint" style="display:block;">
                                    Logo de su empresa. El tamaño máximo permitido es de 250 KB.
                                    Los formatos permitidos son: <b>jpg</b>, <b>bmp</b>, <b>gif</b> y <b>png</b>.
                                </p>
                            </li>
							<li class="SelectCtrl hidden" property="owner_id">
								<label>Dueño de la cuenta:</label>
								<select></select>
							</li>
						</ul>
		    			<p class="form-buttons">
			 				<button class="accept SaveBtn">GUARDAR LOS CAMBIOS</button>
						</p>
					</form>
			</div>
		</div>
	</div>
</div>

<script>
import { onMount } from 'svelte'

onMount(() => {
  window.$("#account-page").AccountPage("#cuenta");
})
</script>
